import { CommonModule } from '@angular/common';
import { AfterViewInit, Component } from '@angular/core';
import { ICRUDOptions } from '@phx-erp/shared';
import { Contact, ContactSearchInput, SearchInput } from '../../../../generated/generated-types';
import { GenericBaseModelDropDown } from '../../../../shared/components/genericBaseModelDropDown';
import { ContactService } from '../../services/contact.service';


@Component({
  selector: 'app-contact-drop-down',
  templateUrl: './contact-drop-down.component.html',
  providers: [ContactService],
  standalone: true,
  imports: [
    CommonModule
  ]
})
export class ContactDropDownComponent extends GenericBaseModelDropDown<Contact> implements AfterViewInit {

  constructor(private service: ContactService) {
    super(service, "Contact");
  }

  override ngAfterViewInit() {
    this.buildFilter(); //this needed here?
    super.ngAfterViewInit();
  }

  buildFilter() {

    if (this.props?.attributes?.parentAddressFieldFilter) {

      let idFilter: string = this.formControl.parent.get(this.props.attributes.parentAddressFieldFilter as string)?.value;

      if (!idFilter) { //is this good?
        idFilter = this.model[this.props.attributes.parentAddressFieldFilter];
      }

      if (idFilter) {
        (this.si as ContactSearchInput).ofAddressId = idFilter;
      }

    }
    else {
      (this.si as ContactSearchInput).ofAddressId = null;
    }

  }

  executeSearch(searchInput: SearchInput, options?: ICRUDOptions) {
    this.buildFilter();
    return super.executeSearch(searchInput, options);
  }

}
